import { useState } from "react";
import { CircularProgress, Stack } from "@mui/material";
import { PlayArrow } from "@mui/icons-material";
import ButtonOne from "../../../../common/normal-button";
import { formatApiResult } from "../../otpApi";
import { HelperText, JsonBox } from "./OtpPanelParts";

const SANDBOX_DISABLED_HINT =
  "Sandbox mode isn't enabled for this business. Ask an administrator to turn it on (OTP_SERVICE_SANDBOX_ENABLED) to use Test API.";

// Runs a real sandbox call against the v2 OTP API. `onRun` resolves to { status, body },
// or to null when the inputs aren't ready (the panel shows why through `disabledReason`).
const OtpTestApi = ({ onRun, disabled = false, disabledReason, children }) => {
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);

  const run = async () => {
    setRunning(true);
    try {
      setResult(await onRun());
    } catch (error) {
      setResult({ status: 0, body: { message: error.message } });
    } finally {
      setRunning(false);
    }
  };

  return (
    <Stack spacing={2}>
      {children}
      <ButtonOne
        variant="outlined"
        title={running ? "Testing..." : "Test API"}
        startIcon={running ? <CircularProgress size={16} /> : <PlayArrow />}
        onClick={run}
        disabled={disabled || running}
        sx={{ alignSelf: "flex-start" }}
      />
      {disabled && disabledReason && <HelperText>{disabledReason}</HelperText>}
      {result && (
        <>
          <JsonBox>{formatApiResult(result)}</JsonBox>
          {result.body?.code === "sandbox_disabled" && (
            <HelperText>{SANDBOX_DISABLED_HINT}</HelperText>
          )}
        </>
      )}
    </Stack>
  );
};

export default OtpTestApi;
